export enum ArticleTagType {
    Brand = 'brand',
    Category = 'category',
    Keyword = 'keyword',
}

export type ArticleTag = {
    type: ArticleTagType;
    value: string;
};

/**
 * Full-article shape aligned with LAAC-2089 prose until OpenAPI publishes.
 * Live path/envelope remain owned by LAAC-2089/2090 — mock-only for this story.
 */
export type Article = {
    author?: string | null;
    content: string;
    createdAt: string;
    heroImageUrl: string | null;
    id: string;
    slug: string;
    subtitle?: string | null;
    tags: ArticleTag[];
    title: string;
    topic: string;
    updatedAt: string;
};

export type ArticleRequestParams = {
    slug: string;
    topic: string;
};

export type ArticleSlice = {
    article: Article | null;
    error: string | null;
    loaded: boolean;
    loading: boolean;
    requestKey: string | null;
};

export const defaultArticleSlice: ArticleSlice = {
    article: null,
    error: null,
    loaded: false,
    loading: false,
    requestKey: null,
};

export const getArticleRequestKey = ({ slug, topic }: ArticleRequestParams): string => `${topic}/${slug}`;
